module.exports = __webpack_public_path__ + "static/media/logHistory.05962ef2.svg";